"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "prompt-date mb-1 flex-justify-between align-center" };
const _hoisted_2 = { class: "prompt-message" };
const vue_3 = require("vue");
const provider_1 = require("../../../../provider/provider");
const common_1 = require("../../../../common/common");
const timeZones_1 = __importDefault(require("../../../../common/timeZones"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AutoAIPromptHistory',
    props: {
        prompt: {
            type: Object,
            required: true,
        }
    },
    emits: ["delete-prompt"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const presenter = (0, vue_3.inject)(provider_1.autoAIPresenterInjectKey);
        const emits = __emit;
        const dateString = (0, vue_3.computed)(() => {
            const date = new Date(props.prompt.date);
            return `${(0, common_1.jpShortDateString)(date, timeZones_1.default.ASIA_TOKYO)} ${(0, common_1.dateToKitchenTime)(date, timeZones_1.default.ASIA_TOKYO)}`;
        });
        function selectPrompt() {
            presenter?.selectPrompt(props.prompt);
        }
        function deletePrompt() {
            emits('delete-prompt', props.prompt);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                class: "prompt-history-item font-xsm",
                onClick: selectPrompt
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(dateString.value), 1 /* TEXT */),
                    (0, vue_2.createElementVNode)("span", {
                        class: "prompt-delete-btn",
                        onClick: (0, vue_2.withModifiers)(deletePrompt, ["stop"])
                    }, [...(_cache[0] || (_cache[0] = [
                            (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-close zmdi-hc-lg" }, null, -1 /* CACHED */)
                        ]))])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(__props.prompt.message), 1 /* TEXT */)
            ]));
        };
    }
});
